import { Options, SourceInfo } from 'plyr'
import PlyrOrigin, { APITypes } from 'plyr-react'
import React, { forwardRef } from 'react'

type Props = {
  id: string
  plyrOptions: Options | undefined
}
export const Plyr = React.memo(
  forwardRef<APITypes, Props>(function Tes({ id, plyrOptions }: Props, ref) {
    return (
      <PlyrOrigin
        ref={ref}
        options={plyrOptions}
        source={{} as SourceInfo}
        id={id}
        className='plyr-react plyr'
      />
    )
  }),
)
